<template>
  <h2><slot /></h2>
</template>

<script>
export default {
  name: 'Title2',
}
</script>
